import { styled } from 'styled-components';
import { pxToRem } from 'modules/spacing';
export const ButtonGroupContainer = styled.div `
  z-index: 0;
  position: relative;
  display: flex;
  white-space: nowrap;

  ${(props) => props.$stretch && 'width: 100%;'}

  & > * {
    position: relative;

    &:focus-visible,
    &:active {
      z-index: 2;
    }
  }

  /* Base UI adds hidden spans next to a menu trigger while its popup is open,
     which breaks :first-child/:last-child. Skip them when counting positions. */
  & > :nth-child(n + 2 of :not([data-base-ui-focus-guard], [aria-owns])) {
    margin-left: -${pxToRem(1)};
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  & > :nth-last-child(n + 2 of :not([data-base-ui-focus-guard], [aria-owns])) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
